/* global G */
import { getUrl } from '@platform/adapter/note/helper'
import { getFirstItem } from 'lib/util'

/**
 * Attempts to delete a note from the server. On success, it also removes it from the adapter's
 * data and then dispatches a G.DONE event.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 */
const fn = app => async ({ detail }) => {
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const adapter = app[G.ADAPTER][G.NOTE]
  const adapterData = adapter[G.DATA]
  const { key } = detail[G.DATA]

  const url = getUrl(app, { key })
  const response = await app[G.ADAPTER][G.HTTP][G.API].delete({ url })
  const result = getFirstItem(response)

  if (result.ok) {
    const itemIndex = adapterData.findIndex(dataItem => dataItem.key === key)
    adapterData.splice(itemIndex, 1)

    eventBus.dispatch(eventBus.type(G.NOTE, G.DONE), { [G.DATA]: adapterData })
  }
}

export default fn
